import React from "react";
import Checkbox from "@material-ui/core/Checkbox";


const renderCheckbox = ({ input, label }) => {
  return (
    <div className="form-group">
      <label>{label}</label>
      <Checkbox
        label={label}
        checked={input.value ? true : false}
        onChange={input.onChange}
        color="primary"
      />
    </div>
  );
};

export default renderCheckbox;



// WEBPACK FOOTER //
// ./src/components/wizardSection/renderCheckBoxField.jsx